import React, { useState } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost:8000";
const card = "rounded-xl border border-[#00ff90]/30 bg-[#0d0d0d] shadow-[0_0_12px_#00ff9022]";
const inputCls = "w-full bg-black border border-[#00ff90]/20 rounded-lg px-3 py-2 text-sm text-white outline-none focus:border-[#00ff90]/50 transition-colors resize-none placeholder-white/20";
const labelCls = "text-xs text-[#00ff90]/50 uppercase tracking-wider block mb-1.5";

const FIELDS = [
  { key: "achievements", label: "Key Achievements", placeholder: "What did you accomplish this period?" },
  { key: "challenges",   label: "Challenges Faced",  placeholder: "What obstacles did you encounter?" },
  // Field key MUST match the API contract (PerformanceReview.goals_next); the
  // old `goals` key was silently dropped by the schema, losing this text.
  { key: "goals_next",   label: "Goals for Next Period", placeholder: "What do you plan to focus on next?" },
];

export default function SelfReviewForm() {
  const [form,       setForm]       = useState({ achievements: "", challenges: "", goals_next: "" });
  const [submitting, setSubmitting] = useState(false);
  const [submitted,  setSubmitted]  = useState(false);
  const [error,      setError]      = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);
    try {
      const token = localStorage.getItem("token");
      const res = await fetch(`${API_BASE}/api/performance/self-review`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify(form),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setSubmitted(true);
      setForm({ achievements: "", challenges: "", goals_next: "" });
      setTimeout(() => setSubmitted(false), 4000);
    } catch (e) {
      setError(e.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className={card}>
      <div className="px-5 py-4 border-b border-white/5">
        <span className="text-xs text-[#00ff90]/60 uppercase tracking-widest font-medium">Self Review</span>
      </div>

      <form onSubmit={handleSubmit} className="p-5 space-y-4">
        {FIELDS.map(({ key, label, placeholder }) => (
          <div key={key}>
            <label className={labelCls}>{label}</label>
            <textarea
              name={key}
              value={form[key]}
              onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
              placeholder={placeholder}
              rows={3}
              className={inputCls}
            />
          </div>
        ))}

        {error     && <p className="text-red-400 text-xs">⚠ {error}</p>}
        {submitted && <p className="text-[#00ff90] text-xs">✓ Self review submitted successfully.</p>}

        <div className="flex justify-end">
          <button type="submit" disabled={submitting}
            className="text-xs px-5 py-2 rounded-lg bg-[#00ff90]/15 text-[#00ff90] border border-[#00ff90]/30 hover:bg-[#00ff90]/25 disabled:opacity-40 transition-colors font-medium">
            {submitting ? "Submitting…" : "Submit Review"}
          </button>
        </div>
      </form>
    </div>
  );
}